import React from 'react'
import PropTypes from 'prop-types'

export const TabContent = ({ children, isActive }) => {
  return (
    <div className={`content-tab flex-container ${isActive ? 'active' : 'hidden'}`}>
      {children}
    </div>
  )
}

TabContent.propTypes = {
  children: PropTypes.node.isRequired,
  isActive: PropTypes.bool.isRequired,
}

export default TabContent



// WEBPACK FOOTER //
// ./src/components/Tab/TabContent.js